import classNames from "classnames";
import Modal from "components/v2/Modal";
import ModalBody from "components/v2/Modal/ModalBody";
import ModalFooter from "components/v2/Modal/ModalFooter";
import ModalButtonPrimary from "components/v2/Modal/ModalFooter/ModalButtonPrimary";
import ModalButtonSecondary from "components/v2/Modal/ModalFooter/ModalButtonSecondary";
import ModalTitle from "components/v2/Modal/ModalTitle";
import React from "react";

import commonStyles from "../../../v2/style.module.css";
import styles from "./style.module.css";

const CustomizeCookiesModal = ({
  openModal,
  onCloseModal,
  contentComponent,
  handleAcceptAllCookie,
  handleAcceptCookie,
  handleRejectCookie,
}) => {
  return (
    <>
      <Modal open={openModal} title="" footer={null} className={styles.container} onCancel={onCloseModal}>
        <ModalTitle>Customize Consent Preferences</ModalTitle>
        <ModalBody className={classNames(styles.content, commonStyles.scrollBar)}>{contentComponent}</ModalBody>
        <ModalFooter className={styles.modalFooter}>
          <ModalButtonSecondary onClick={handleRejectCookie} className={commonStyles.tertiaryButton}>
            Reject All
          </ModalButtonSecondary>
          <ModalButtonSecondary onClick={handleAcceptCookie} className={commonStyles.tertiaryButton}>
            Accept
          </ModalButtonSecondary>
          <ModalButtonPrimary onClick={handleAcceptAllCookie} className={commonStyles.primaryButton}>
            Accept All
          </ModalButtonPrimary>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CustomizeCookiesModal;
